import {Ga} from "./ga";

require('es6-promise').polyfill();
import * as Raven from 'raven-js';
import {playerBanner} from "./plugins/videojs-player-banner/plugin";
import {playerOverlay} from "./plugins/videojs-overlay/plugin";

import './player.css';

import vttThumbnails = require('videojs-vtt-thumbnails');
import * as videojs from "video.js";

require('videojs-contrib-quality-levels');
require('videojs-http-source-selector');
// require('videojs-hls-quality-selector');

const SECONDS = 1000;
const MINUTES = 60 * SECONDS;
const HOURS = 60 * MINUTES;

const userSession = require('uuid-js').create().toString();

const TYPES = {
    DASH: "application/dash+xml",
    HLS: "application/x-mpegURL"
};

type event = "ended" | "error" | "play" | "pause" | "ready" | "clickBanner" | "expire";
Raven
    .config("https://d2cf0b1ff2b14aaaabe324d9e8324daa@sentry.tawenda-tech.org/6",
        {
            release: "__VERSION__",
            whitelistUrls: [
                /cdn\.tawenda-tech\.org/,
            ]
        })
    .install();

Raven.setUserContext({
    id: userSession
});

export class Player {
    private player: videojs.Player;

    private ga: Ga;
    private expireTimeout: any = null;

    constructor(id: string, private sources, private vtt, {banner = {}, accessType = "unknown"} = {}) {

        videojs.registerPlugin('vttThumbnails', vttThumbnails);

        Raven.captureBreadcrumb({
            message: 'Instantiate player',
            category: 'player',
            data: {sources, vtt}
        });

        this.ga = new Ga(accessType = accessType);
        this.expireTimeout = setTimeout(() => this.expired(), 3 * HOURS);

        this.player =  videojs(id, (<any>{
            fluid: true,
            plugins: {
                httpSourceSelector:
                    {
                        default: 'auto'
                    }
            }
        })) as any;



        // (<any>this.player).tech_.on((<any>window).Hls.Events.LEVEL_LOADED, (event, data) => this.addBreadCrumbForHLSLevel(data));
        // (<any>this.player).tech_.on((<any>window).Hls.Events.ERROR, (event, data) => this.onHlsError(data));

        this.player.on("error",
            (event) => {

                const error = (<any>this.player).error();
                const message = error && error.message ? error.message : "unknown error";
                Raven.captureException(new Error(message),
                    {
                        fingerprint: [
                            error.code, error.message],
                        extra: {event, error}
                    });
            });

        // this.player.on("loadedmetadata", event => console.debug(event));

        this.player.src(this.filteredSources(this.sources));
        (this.player as any).vttThumbnails({
            src: this.vtt
        });

        this.player.httpSourceSelector();

        // const qualityLevels = this.player.qualityLevels();
        // this.player.hlsQualitySelector({
        //     displayCurrentQuality: false,
        // });

        this.once("play", (event: any) => {
            this.track("play", event);
        });
        this.on("error", (event: any) => this.track("error", event));

        let {enabled: bannerEnabled = false, text = 'Voir la vidéo complète en HD'} = (banner as any);
        if (bannerEnabled) {
            videojs.registerPlugin('playerBanner', playerBanner);
            (this.player as any).playerBanner({text: text});
        }

        videojs.registerPlugin('playerOverlay', playerOverlay);
        (this.player as any).playerOverlay(text = "La vidéo a expiré, cliquez ici pour recharger la page");
    }

    // private onHlsError(data) {
    //     Player.addBreadCrumb(data.details, data);
    // }
    //
    // private addBreadCrumbForHLSLevel(data) {
    //
    //     Player.addBreadCrumb('HLS Level loaded', {
    //         type: data.details.type,
    //         targetduration: data.details.targetduration,
    //         totalduration: data.details.totalduration,
    //         version: data.details.version,
    //         url: data.details.url,
    //         level: data.level,
    //         totalFragments: data.details.fragments.length,
    //         sample: data.details.fragments.slice(0, 10).map(fragment => fragment.url)
    //     })
    //
    // }

    private static addBreadCrumb(message, data = {}) {
        Raven.captureBreadcrumb({
            message, data,
            category: 'player',
        });
    }

    private expired() {
        this.track("expired");
        this.player.pause();
        (this.player as any).playerOverlay.show();
        (this.player as any).on('overlay-click', _ => (window as any).location.reload());

        try {
            (<any>this.player).tech_.sourceHandler_.hls.stopLoad();
        } catch (e) {};

    }

    private track(event: string, extra: any = null) {
        Player.addBreadCrumb(event, {extra});
        this.ga.sendEvent('general', event);
    }

    dispose() {
        if (this.player) {
            clearTimeout(this.expireTimeout);
            this.player.dispose();
            this.player = null;
        }
    }

    pause() {
        if (this.player) {
            this.player.pause();
        }
    }

    play() {
        if (this.player) {
            this.player.play();
        }
    }

    on(eventName: event, callback: (eventObject: Event) => void) {
        if (this.player) {
            this.player.on(eventName, callback);
        }
    }

    once(eventName: event, callback: (eventObject: Event) => void) {
        if (this.player) {
            const callbackWrap = (eventObject: Event) => {
                callback(eventObject);
                this.off(eventName, callbackWrap);
            };
            this.player.on(eventName, callbackWrap);
        }
    }


    off(eventName: event, callback: (eventObject: Event) => void) {
        if (this.player) {
            this.player.off(eventName, callback);
        }
    }

    /**
     * Set position in second if value, else get position
     * @param {number} value
     */
    currentTime(value?: number) {
        if (this.player) {
            return this.player.currentTime(value);
        }
    }

    /**
     * Set rate if value, else get rate
     * @param {number} value
     */
    playbackRate(value?: number) {
        if (this.player) {
            this.player.playbackRate(value);
        }
    }

    /**
     * Define if sounds muted or not
     * @param {boolean} value
     */
    muted(value: boolean) {
        if (this.player) {
            (this.player as any).muted(value);
        }
    }

    private filteredSources(sources) {
        const weights = {
            "": 0,
            "maybe": 1,
            "probably": 2
        };
        let hls = weights[(this.player as any).canPlayType(TYPES.HLS)] || 0;
        if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
            hls = 3
        }
        const removeTypes = [TYPES.DASH];
        if (hls === 0) {
            removeTypes.push(TYPES.HLS)
        }
        return sources.filter(s => removeTypes.indexOf(s.type) === -1);
    }

    private static _doGetUrl(url: string): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            try {
                const Xhr = (new XMLHttpRequest().withCredentials === undefined) ? (window as any).XDomainRequest : (window as any).XMLHttpRequest;
                const xhr = new Xhr();
                xhr.open('GET', url);
                xhr.onerror = e => {
                    Player.addBreadCrumb('xhr error', {url, e});
                    reject(e);
                };
                xhr.onload = _ => {
                    if (xhr.status === 200) {
                        resolve(JSON.parse(xhr.responseText));
                    } else {
                        Player.addBreadCrumb('xhr unexpected status', {url, status: xhr.status});
                        reject(new Error(xhr.status));
                    }
                };
                xhr.send();
            } catch (e) {
                Player.addBreadCrumb('xhr unexpected error', {url, e});
                reject(e);
            }
        });
    }

    private static exponentialTruncatedBackoff(slotTime: number = 100, truncate: number = Number.MAX_VALUE, retry: number = Number.MAX_VALUE) {
        return (iteration: number): number => {
            if (iteration > retry) {
                return null;
            }
            return Math.random() * slotTime * (2 ^ Math.min(iteration, truncate) - 1);
        };
    };

    private static _getUrl(url: string, retryPolicy: (iteration: number) => number, iteration: number = 0): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            Player._doGetUrl(url)
                .then(resolve)
                .catch(e => {
                    const timeout = retryPolicy(iteration + 1);
                    if (timeout === null) {
                        throw e;
                    } else {
                        setTimeout(() => this._getUrl(url, retryPolicy, iteration + 1).then(resolve), timeout);
                    }
                });
        });
    }

    public static getUrl(url: string): Promise<any> {
        return this._getUrl(`${url}&se=${userSession}`, Player.exponentialTruncatedBackoff(100, 10000, 100));
    }

    public static getSources(url: string): Promise<any> {
        Raven.captureBreadcrumb({
            message: 'get the sources',
            category: 'player',
            data: {url}
        });
        return new Promise<any>((resolve, reject) => {
            Player.getUrl(url).then(response => {
                Raven.captureBreadcrumb({
                    message: 'received the sources',
                    category: 'player',
                    data: {response}
                });
                let sources = {streams: [], vtt: null, downloads: []};
                if (response.sources.hls) {
                    sources.streams.push({
                        src: response.sources.hls,
                        type: "application/x-mpegURL",
                        label: 'Auto'
                    });
                }
                if (response.sources.dash) {
                    sources.streams.push({
                        src: response.sources.dash,
                        type: "application/dash+xml",
                        label: 'Auto'
                    })
                }
                if (response.sources.mp4) {
                    for (var i = 0, l = response.sources.mp4.length; i < l; i++) {
                        sources.streams.push({
                            src: response.sources.mp4[i].file,
                            type: 'video/mp4',
                            label: response.sources.mp4[i].label
                        });
                        if (response.sources.mp4[i].download) {
                            sources.downloads.push({
                                file: response.sources.mp4[i].file,
                                label: response.sources.mp4[i].label,
                                size: undefined
                            });
                        }
                    }
                }
                if (response.vtt) {
                    sources.vtt = response.vtt;
                }
                resolve(sources);
            }).catch(e => {
                Raven.captureException(e);
                reject('Something went wrong')
            })
        })
    };


}